var map = {
	"./404.svg": 1543,
	"./bug.svg": 1544,
	"./chart.svg": 1545,
	"./clipboard.svg": 1546,
	"./component.svg": 1547,
	"./drag.svg": 1548,
	"./email.svg": 1549,
	"./example.svg": 1550,
	"./excel.svg": 1551,
	"./eye.svg": 1552,
	"./form.svg": 1553,
	"./icon.svg": 1554,
	"./lock.svg": 1555,
	"./password.svg": 1556,
	"./people.svg": 1557,
	"./qq.svg": 1558,
	"./star.svg": 1559,
	"./tab.svg": 1560,
	"./table.svg": 1561,
	"./theme.svg": 1562,
	"./trendChart1.svg": 1563,
	"./trendChart2.svg": 1564,
	"./trendChart3.svg": 1565,
	"./user.svg": 1566,
	"./wechat.svg": 1567,
	"./zip.svg": 1568
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1843;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 1843
// module chunks = 1